import React from 'react';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import i18n from '../../i18n';


export const notify = (message, place, type) => {
    switch (type) {
        case 1:
            NotificationManager.info(message, i18n.t('notifications.info'));
            break;
        case 2:
            NotificationManager.success(message, i18n.t('notifications.success'));
            break;
        case 4:
            NotificationManager.warning(message);
            break;
        case 3:
            NotificationManager.error(message, i18n.t('notifications.sorry'));
            break;
    }
};
